import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

export default function FormOnEditRole(props) {
	const { open, handleClose, editData, fetchAPI } = props;
	const { register, handleSubmit, errors } = useForm();
	const [onError, setOnError] = useState(true);
	const [editDatas, setEditDatas] = useState({
		id: "",
		layanan: "",
		nama: "",
		sla: "",
		deskripsi: "",
	});

	const { layanan, nama, sla, deskripsi } = editDatas;
	const onSubmit = async () => {
		await fetchAPI("edit", editDatas);
	};

	useEffect(() => {
		if (
			editData?.nama === editDatas?.nama &&
			editData?.sla === editDatas?.sla &&
			editData?.layanan === editDatas?.layanan &&
			editData?.deskripsi === editDatas?.deskripsi
		) {
			return setOnError(true);
		}
		return setOnError(false);
	}, [editData, editDatas, onError]);

	useEffect(() => {
		if (editData) {
			setEditDatas({
				id: editData.id,
				layanan: editData.layanan,
				nama: editData.nama,
				sla: editData.sla,
				deskripsi: editData.deskripsi,
			});
		}
	}, [editData]);

	const handleFieldChange = (e) =>
		setEditDatas({ ...editDatas, [e.target.name]: e.target.value });

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<form onSubmit={handleSubmit(onSubmit)}>
					<DialogTitle id="form-dialog-title">Edit On Category</DialogTitle>
					<DialogContent>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={12}>
								<TextField
									disabled
									label="ID Layanan"
									fullWidth
									type="string"
									value={layanan}
									variant="outlined"
								/>
							</Grid>
							<Grid item xs={12} sm={12}>
								<TextField
									id="nama"
									name="nama"
									label="Name Category"
									error={errors.nama}
									fullWidth
									placeholder="Type your Nama"
									type="string"
									value={nama}
									variant="outlined"
									onChange={handleFieldChange}
									inputRef={register({
										required: {
											value: true,
											message: "Name tidak boleh kosong",
										},
									})}
									InputLabelProps={{ shrink: true }}
									helperText={errors.nama && errors.nama.message}
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<TextField
									id="sla"
									name="sla"
									label="SLA Per Minutes"
									error={errors.sla}
									placeholder="Type your SLA Per Minutes"
									fullWidth
									type="number"
									value={sla}
									variant="outlined"
									onChange={handleFieldChange}
									inputRef={register({
										required: {
											value: true,
											message: "sla tidak boleh kosong",
										},
									})}
									InputLabelProps={{ shrink: true }}
									helperText={errors.sla && errors.sla.message}
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<TextField
									id="deskripsi"
									name="deskripsi"
									label="Description"
									placeholder="Type your deskripsi"
									type="string"
									value={deskripsi}
									variant="outlined"
									error={errors.deskripsi}
									onChange={handleFieldChange}
									inputRef={register({
										required: {
											value: true,
											message: "Username tidak boleh kosong",
										},
									})}
									InputLabelProps={{ shrink: true }}
									helperText={errors.deskripsi && errors.deskripsi.message}
									fullWidth
								/>
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions>
						<Button type="submit" color="primary" disabled={onError}>
							Save
						</Button>
						<Button onClick={handleClose} color="secondary">
							Cancel
						</Button>
					</DialogActions>
				</form>
			</Dialog>
		</div>
	);
}
